import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {first} from "rxjs/operators";
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {FlashMessageService} from "@shared/partials/flash-message/flash-message.service";


@Component({
  selector: 'app-user-change-dialog',
  templateUrl: './user-change-dialog.component.html',
  styles: [`
    .mat-form-field{
      width: 100%;
    }
  `]
})
export class UserEmailChangeDialogComponent implements OnInit {
  public form!: FormGroup
  public isEnd : boolean = false
  private readonly changeEmailUrl: string = '/auth/email_change/request'
  public isLoading = false
  public isEmailSent = false

  constructor(
    private readonly dialogRef: MatDialogRef<UserEmailChangeDialogComponent>,
    private readonly httpClient: HttpClient,
    private readonly formBuilder: FormBuilder,
    private readonly flashMessageService:FlashMessageService
  ) {
    this.isEnd = false
    this.changeEmailUrl = '/auth/email_change/request'
    this.isLoading = false
    this.isEmailSent = false
  }

  public ngOnInit() {
    this.form = this.formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.email]),
    })
  }

  public change_user(){
    if(this.form.valid) {
      this.isLoading = true;
      this.httpClient
        .post(this.changeEmailUrl, {...this.form.value, source_url: `${location.origin}/recovery_email`})
        .pipe(first())
        .subscribe(
          (response: HttpResponse<any>) => {
            this.isEmailSent = true
            this.isLoading = false
          },
          (response: HttpErrorResponse) => {
            this.dialogRef.close()
            response.status === 409 ? this.showEmailConflictMessage() : this.showEmailGenericErrorMessage()
            this.isLoading = false
          }
        )
    }
  }

  private showEmailConflictMessage(){
    this.flashMessageService.showCustom({
      color: 'danger',
      title: 'Questo indirizzo email è già utilizzato',
      text: "Stai cercando di cambiare il tuo indirizzo email con uno già utilizzato da te o da un altro utente. Controlla che l'indirizzo email che hai inserito sia corretto oppure contattaci tramite la pagina contatti."
    })
  }

  private showEmailGenericErrorMessage(){
    this.flashMessageService.showCustom({
      color: 'danger',
      title: 'Errore nell invio della email',
      text: 'Non siamo riusciti ad inviare un email al tuo nuovo indirizzo. Per favore riprova oppure contattaci tramite la pagina contatti.'
    })
  }
}
